import React, { Component } from 'react'
import { connect } from 'react-redux'


import {Card, CardActions, CardHeader, CardMedia, CardTitle, CardText} from 'material-ui/Card'

import { doc, dirtyRead } from 'selectors/common'
import { makePropertyVendorsSelector } from 'selectors/vendor'

import Section from 'components/Section'
import VendorList from './List'
import EntityAttachments from 'components/EntityAttachments'
import dataActions from 'actions/dataActions'
import AddButton from 'components/AddButton'

let select = dirtyRead(
	(state, props) => {
		let propertyVendors = makePropertyVendorsSelector()
		return ({
			vendors: propertyVendors(state, props)
		})
	}
)

export class Vendors extends Component{
	render(){
		let { props } = this
		return(
			<Section
				id="property/merchants"
				title="Vendors"
				badge={props.vendors.length}
				rightButton={<AddButton object={{type:"merchant", propertyID:props.propertyID}} />}
			>
				<VendorList propertyID={props.propertyID} />
			</Section>
		)
	}
}

export default connect(select, dataActions)(Vendors)



// WEBPACK FOOTER //
// ./src/routes/manager/propertyForm/vendors/index.js